module.exports = __webpack_public_path__ + "static/media/v.ce9a1b8f.ogv";